import { render } from "./TheBoat.vue?vue&type=template&id=445e8d9c"
import script from "./TheBoat.vue?vue&type=script&lang=js"
export * from "./TheBoat.vue?vue&type=script&lang=js"

import exportComponent from "C:\\WORK\\tft prod\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__